import Button from "@rio-cloud/rio-uikit/Button";
import Spinner from "@rio-cloud/rio-uikit/Spinner";
import { useIntl } from "react-intl";
import { useT } from "@hooks";

export interface SelectionBarProps {
  count: number;
  totalAmount: number;
  isFilterSelection?: boolean;
  selectAllFromFilterTotal?: number | null;
  isSelectingAllFromFilter?: boolean;
  onSelectAllFromFilter?: () => void;
  onClear: () => void;
  onDelete: () => void;
}

const SelectionBar = ({
  count,
  totalAmount,
  isFilterSelection = false,
  selectAllFromFilterTotal,
  isSelectingAllFromFilter = false,
  onSelectAllFromFilter,
  onClear,
  onDelete,
}: SelectionBarProps) => {
  const t = useT();
  const { locale } = useIntl();

  if (count === 0) return null;

  const canSelectAllFromFilter = !isFilterSelection && !!selectAllFromFilterTotal && !!onSelectAllFromFilter;

  return (
    <div
      className="display-flex flex-wrap align-items-center justify-content-between gap-10 padding-x-15 padding-y-10 margin-bottom-15 rounded bg-highlight-lighter"
      data-testid="batch-selection-bar"
    >
      <div className="display-flex flex-wrap align-items-center gap-15">
        <span className="text-size-14 text-medium">{t("batchDelete.selection.count", { count })}</span>
        <span className="text-medium">
          {t("batchDelete.selection.total", {
            total: totalAmount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
          })}
        </span>
        {isFilterSelection && <span className="text-color-dark">{t("batchDelete.selection.allFromFilter")}</span>}
        {canSelectAllFromFilter && (
          <button
            type="button"
            className="btn btn-link btn-action padding-0"
            disabled={isSelectingAllFromFilter}
            onClick={onSelectAllFromFilter}
          >
            {isSelectingAllFromFilter && (
              <span className="margin-right-5">
                <Spinner isInline />
              </span>
            )}
            {t("batchDelete.selection.selectAllFromFilter", {
              total: selectAllFromFilterTotal.toLocaleString(locale),
            })}
          </button>
        )}
      </div>
      <div className="display-flex flex-wrap gap-10 width-100pct-xs">
        <Button className="rounded-small width-100pct-xs" onClick={onClear}>
          {t("batchDelete.selection.clear")}
        </Button>
        <Button
          bsStyle={Button.DANGER}
          iconName="rioglyph-trash"
          className="rounded-small width-100pct-xs"
          onClick={onDelete}
        >
          {t("batchDelete.selection.delete", { count })}
        </Button>
      </div>
    </div>
  );
};

export default SelectionBar;
